import { supabase } from './supabase.js';

export function formatPartnerPlaceLabel(place) {
  if (!place) return 'Partner';
  const name = String(place.company_name || place.code || 'Partner').trim();
  const city = String(place.city || '').trim();
  return city ? `${name} · ${city}` : name;
}

export async function fetchPartnersForListingCoverage(coverageRole, sellerMode = 'physical') {
  const role = String(coverageRole || '').trim();
  const mode = String(sellerMode || 'physical').trim();
  const { data, error } = await supabase.rpc('list_partners_for_listing_coverage', {
    p_coverage_role: role,
    p_seller_mode: mode,
  });
  if (error) {
    console.error('[listingPartnerLogisticsService] list_partners', error.message);
    return { partners: [], error: error.message };
  }
  return { partners: Array.isArray(data) ? data : [], error: null };
}

/** Unión de partners compatibles con cualquiera de los modos ofrecidos. */
export async function fetchPartnersForListingCoverageModes(coverageRole, sellerModes = ['physical']) {
  const modes = Array.isArray(sellerModes) && sellerModes.length ? sellerModes : ['physical'];
  const byId = new Map();
  for (const mode of modes) {
    const { partners, error } = await fetchPartnersForListingCoverage(coverageRole, mode);
    if (error) return { partners: [], error };
    for (const p of partners) {
      byId.set(p.partner_id, p);
    }
  }
  return { partners: [...byId.values()], error: null };
}

export async function fetchListingPartnerCoverage(listingId) {
  const lid = String(listingId ?? '').trim();
  if (!lid) return { coverage: [], error: 'missing_listing' };
  const { data, error } = await supabase.rpc('get_listing_partner_coverage', { p_listing_id: lid });
  if (error) {
    console.error('[listingPartnerLogisticsService] get_coverage', error.message);
    return { coverage: [], error: error.message };
  }
  return { coverage: Array.isArray(data) ? data : [], error: null };
}

export async function saveListingPartnerCoverage({
  listingId,
  storePartnerIds = [],
  pickupPartnerIds = [],
  modesStore = null,
  modesPickup = null,
  modeStore = null,
  modePickup = null,
}) {
  const lid = String(listingId ?? '').trim();
  if (!lid) return { error: 'missing_listing' };
  const { error } = await supabase.rpc('set_listing_partner_coverage', {
    p_listing_id: lid,
    p_store_partner_ids: storePartnerIds,
    p_pickup_partner_ids: pickupPartnerIds,
    p_modes_store: modesStore,
    p_modes_pickup: modesPickup,
    p_mode_store: modeStore,
    p_mode_pickup: modePickup,
  });
  if (error) {
    console.error('[listingPartnerLogisticsService] set_coverage', error.message);
    return { error: error.message };
  }
  return { error: null };
}

export async function updatePartnerRoleLogistics({
  role,
  sellerDropoffPhysical,
  sellerDropoffShipment,
  buyerHandoverPhysical,
  buyerOutboundShipment = false,
}) {
  const { error } = await supabase.rpc('update_partner_role_logistics', {
    p_role: role,
    p_seller_dropoff_physical: !!sellerDropoffPhysical,
    p_seller_dropoff_shipment: !!sellerDropoffShipment,
    p_buyer_handover_physical: !!buyerHandoverPhysical,
    p_buyer_outbound_shipment: !!buyerOutboundShipment,
  });
  if (error) return { error: error.message };
  return { error: null };
}
